{
    "Timezone_Default": "Standard",
    "Timezone_International_Date_Line_West": "(GMT-12:00) Internationale Datumsgrenze West",
    "Timezone_Midway": "(GMT-11:00) Midwayinseln",
    "Timezone_Hawaii": "(GMT-10:00) Hawaii",
    "Timezone_Alaska_DLS": "(GMT-09:00) Alaska [DLS]",
    "Timezone_Pacific_Time_US_Canada_DLS": "(GMT-08:00) Pazifische Zeit (USA \/ Kanada) [DLS]",
    "Timezone_Tijuana_Baja_California_DLS": "(GMT-08:00) Tijuana, Baja California [DLS]",
    "Timezone_Arizona": "(GMT-07:00) Arizona",
    "Timezone_Chihuahua_La_Paz_Mazatlan": "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    "Timezone_Mountain_Time_US_Canada_DLS": "(GMT-07:00) Mountain Time (USA \/ Kanada) [DLS]",
    "Timezone_Central_America": "(GMT-06:00) Mittelamerika",
    "Timezone_Central_Time_US_Canada_DLS": "(GMT-06:00) Central Time (USA \/ Kanada) [DLS]",
    "Timezone_Guadalajara_Mexico_City_Monterrey": "(GMT-06:00) Guadalajara, Mexiko-Stadt, Monterrey",
    "Timezone_Saskatchewan": "(GMT-06:00) Saskatchewan",
    "Timezone_Bogota_Lima_Quito_Rio_Branco": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    "Timezone_Eastern_Time_US_Canada_DLS": "(GMT-05:00) Eastern Time (USA \/ Kanada) [DLS]",
    "Timezone_Indiana_East_DLS": "(GMT-05:00) Indiana (Ost) [DLS]",
    "Timezone_Caracas": "(GMT-04:00) Caracas",
    "Timezone_Atlantic_Time_Canada_DLS": "(GMT-04:00) Atlantische Zeit (Kanada) [DLS]",
    "Timezone_La_Paz": "(GMT-04:00) La Paz",
    "Timezone_Manaus": "(GMT-04:00) Manaus",
    "Timezone_Georgetown": "(GMT-04:00) Georgetown",
    "Timezone_Santiago_DLS": "(GMT-04:00) Santiago [DLS]",
    "Timezone_Newfoundland_DLS": "(GMT-03:30) Neufundland [DLS]",
    "Timezone_Brasilia": "(GMT-03:00) Brasilia",
    "Timezone_Buenos_Aires": "(GMT-03:00) Buenos Aires",
    "Timezone_Montevideo": "(GMT-03:00) Montevideo",
    "Timezone_Greenland_Godthab_DLS": "(GMT-02:00) Grönland (Godthab, Nuuk) [DLS]",
    "Timezone_Mid_Atlantic": "(GMT-02:00) Mittelatlantik",
    "Timezone_Azores_DLS": "(GMT-01:00) Azoren [DLS]",
    "Timezone_Cape_Verde_Islands": "(GMT-01:00) Kapverden",
    "Timezone_Dublin_Edinburgh_Lisbon_London_DLS": "(GMT+00:00) Dublin, Edinburgh, Lissabon, London [DLS]",
    "Timezone_Greenwich_Mean_Time": "(GMT+00:00) Greenwich Mean Time",
    "Timezone_Monrovia_Reykjavik": "(GMT+00:00) Monrovia, Reykjavik",
    "Timezone_Amsterdam_Berlin_Rome_Bern_Vienna_DLS": "(GMT+01:00) Amsterdam, Berlin, Rom, Bern, Wien [DLS]",
    "Timezone_Belgrade_Bratislava_Budapest_Prague_DLS": "(GMT+01:00) Belgrad, Bratislava, Budapest, Prag [DLS]",
    "Timezone_Brussels_Copenhagen_Madrid_Paris_DLS": "(GMT+01:00) Brüssel, Kopenhagen, Madrid, Paris [DLS]",
    "Timezone_Sarajevo_Skopje_Warsaw_Zagreb_DLS": "(GMT+01:00) Sarajevo, Skopje, Warschau, Zagreb [DLS]",
    "Timezone_Casablanca_DST": "(GMT+01:00) Casablanca [DLS]",
    "Timezone_West_Central_Africa": "(GMT+01:00) Westzentralafrika",
    "Timezone_Windhoek": "(GMT+02:00) Windhoek",
    "Timezone_Athens_Bucharest": "(GMT+02:00) Athen; Bukarest",
    "Timezone_Beirut_DLS": "(GMT+02:00) Beirut [DLS]",
    "Timezone_Cairo_DLS": "(GMT+02:00) Kairo [DLS]",
    "Timezone_Harare_Pretoria": "(GMT+02:00) Harare, Pretoria",
    "Timezone_Helsinki_Kyiv_Riga_Sofia_Tallinn_Vilnius_DLS": "(GMT+02:00) Helsinki, Kiew, Riga, Sofia, Tallinn, Vilnius [DLS]",
    "Timezone_Jerusalem_DLS": "(GMT+02:00) Jerusalem [DLS]",
    "Timezone_Baghdad_DLS": "(GMT+03:00) Bagdad [DLS]",
    "Timezone_Amman": "(GMT+03:00) Amman; Istanbul",
    "Timezone_Kuwait_Riyadh": "(GMT+03:00) Kuwait, Riad",
    "Timezone_Moscow_St_Petersburg_Volgograd": "(GMT+03:00) Moskau, St. Petersburg, Wolgograd",
    "Timezone_Minsk": "(GMT+03:00) Minsk",
    "Timezone_Nairobi": "(GMT+03:00) Nairobi",
    "Timezone_Tehran": "(GMT+03:30) Teheran",
    "Timezone_Tbilisi": "(GMT+04:00) Tiflis",
    "Timezone_Abu_Dhabi_Muscat": "(GMT+04:00) Abu Dhabi, Maskat",
    "Timezone_Baku": "(GMT+04:00) Baku",
    "Timezone_Mauritius": "(GMT+04:00) Mauritius, Port Louis",
    "Timezone_Yerevan_DLS": "(GMT+04:00) Eriwan [DLS]",
    "Timezone_Kabul": "(GMT+04:30) Kabul",
    "Timezone_Yekaterinburg": "(GMT+05:00) Jekaterinburg",
    "Timezone_Islamabad_Karachi": "(GMT+05:00) Islamabad, Karachi",
    "Timezone_Tashkent": "(GMT+05:00) Taschkent, Astana, Almaty",
    "Timezone_Chennai_Kolkata_Mumbai_New_Delhi": "(GMT+05:30) Chennai, Kalkutta, Mumbai, Neu-Delhi",
    "Timezone_Sri_Jayawardenepura": "(GMT+05:30) Colombo, Sri Jayawardenepura",
    "Timezone_Katmandu": "(GMT+05:45) Katmandu",
    "Timezone_Dhaka": "(GMT+06:00) Dhaka",
    "Timezone_Yangon_Rangoon": "(GMT+06:30) Yangon (Rangun)",
    "Timezone_Bangkok_Jakarta": "(GMT+07:00) Bangkok, Jakarta",
    "Timezone_Krasnoyarsk": "(GMT+07:00) Krasnojarsk",
    "Timezone_Novosibirsk": "(GMT+07:00) Nowosibirsk",
    "Timezone_Hong_Kong": "(GMT+08:00) Peking, Chongqing, Hongkong, Urumqi",
    "Timezone_Irkutsk": "(GMT+08:00) Irkutsk, Ulaan Bataar",
    "Timezone_Kuala_Lumpur": "(GMT+08:00) Kuala Lumpur, Singapur",
    "Timezone_Perth": "(GMT+08:00) Perth",
    "Timezone_Taipei": "(GMT+08:00) Taipeh",
    "Timezone_Tokyo": "(GMT+09:00) Osaka, Sapporo, Tokio",
    "Timezone_Seoul": "(GMT+09:00) Seoul",
    "Timezone_Yakutsk": "(GMT+09:00) Jakutsk",
    "Timezone_Adelaide": "(GMT+09:30) Adelaide [DLS]",
    "Timezone_Darwin": "(GMT+09:30) Darwin",
    "Timezone_Brisbane": "(GMT+10:00) Brisbane",
    "Timezone_Canberra_Melbourne_Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney [DLS]",
    "Timezone_Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
    "Timezone_Hobart": "(GMT+10:00) Hobart [DLS]",
    "Timezone_Vladivostok": "(GMT+10:00) Wladiwostok",
    "Timezone_Magadan": "(GMT+11:00) Magadan, Salomonen, Neukaledonien",
    "Timezone_Auckland_Wellington": "(GMT+12:00) Auckland, Wellington [DLS]",
    "Timezone_Fiji": "(GMT+12:00) Fidschi, Kamtschatka, Marshallinseln",
    "Timezone_Tongatapu": "(GMT+13:00) Tongatapu",
    "Timezone_Samoa": "(GMT+13:00) Samoa",
    "Timezone_Kiritimati": "(GMT+14:00) Kiritimati, Weihnachtsinsel",
    "NAME": "Timezone"
}